import Vue from 'vue'
import VueRouter from 'vue-router'

import NotFoundComponent from '../views/NotFoundComponent.vue'

import Home from '../views/Home.vue'
import Partner from '../views/Partner'

import CpeLC111 from '../views/terminal/CpeLC111'
import T115 from '../views/terminal/T115'
import Ldw931 from '../views/terminal/Ldw931'

import Gc111 from '../views/industry/Gc111'
import T300 from '../views/industry/T300'
import M55 from '../views/industry/M55'
import Lm321 from '../views/industry/Lm321'

import LC800 from '../views/mobile/LC800'
import Recruit from '../views/contact/Recruit'

import Shop from '../views/Shop'
import Upload from '../views/Upload'

import Manual from '../views/Manual'
import Service from '../views/Service'
import Tutorial from '../components/manual/Tutorial'
import Info from '../components/manual/Info'
import Statement from '../components/manual/Statement'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点击菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: NotFoundComponent,
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/partner',
    name: 'Partner',
    component: Partner
  },
  {
    path: '/cpeLC111',
    name: 'CpeLC111',
    component: CpeLC111,
  },
  {
    path: '/t115',
    name: 'T115',
    component: T115,
  },
  {
    path: '/ldw931',
    name: 'Ldw931',
    component: Ldw931,
  },
  {
    path: '/gc111',
    name: 'Gc111',
    component: Gc111,
  },
  {
    path: '/t300',
    name: 'T300',
    component: T300,
  },
  {
    path: '/m55',
    name: 'M55',
    component: M55,
  },
  {
    path: '/lm321',
    name: 'Lm321',
    component: Lm321,
  },
  {
    path: '/lc800',
    name: 'LC800',
    component: LC800,
  },
  {
    path: '/recruit',
    name: 'Recruit',
    component: Recruit,
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload,
  },

  {
    path: '/manual',
    name: 'Manual',
    component: Manual,
  },
  {
    path: '/service',
    name: 'Service',
    component: Service,
    meta: { title: '万唐' },
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: Tutorial,
  },
  {
    path: '/info',
    name: 'Info',
    component: Info,
  },
  {
    path: '/statement',
    name: 'Statement',
    component: Statement,
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

// 解决不同页面跳转保持原始位置，修改为回到页面顶部
router.afterEach((to,from,next)=>{
  window.scrollTo(0,0);
})

export default router
